import { DestroyRef } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms'
import { parsePhoneNumber } from 'awesome-phonenumber'

export const PASSWORD_REGEXP = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]?).{6,}$', '')

const phoneNumberValidator = function (mobileControl: AbstractControl | null, countryCodeControl: AbstractControl | null): ValidationErrors | null {
  const errorResponse = (message: string) => {
    return {
      forbiddenMobile: {
        message,
      },
    }
  }

  // If either control is not available or empty, don't validate (let Validators.required handle empty values)
  if (!countryCodeControl || !mobileControl || !countryCodeControl?.value || !mobileControl?.value) {
    return null
  }
  const country_code = String(countryCodeControl.value as unknown)
  const mobile = String(mobileControl.value as unknown)
  const countryCodePlus = country_code.startsWith('+') ? country_code : '+' + country_code
  const checker = parsePhoneNumber(countryCodePlus + mobile)
  return checker.valid ? null : errorResponse(countryCodePlus + mobile + ' phone number is incorrect')
}

export function MobileValidator(countryCodeControl: AbstractControl | null): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return phoneNumberValidator(control, countryCodeControl)
  }
}

export function CountryCodeValidator(mobileControl: AbstractControl | null): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return phoneNumberValidator(mobileControl, control)
  }
}

export function IsraeliIdValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null // Let required validator handle empty values
    }

    const id = String(control.value as unknown)

    // Check if ID is exactly 9 digits
    if (!/^\d{9}$/.test(id)) {
      return {
        israeliId: {
          message: 'Israeli ID must be exactly 9 digits',
        },
      }
    }

    // Calculate checksum using Israeli ID algorithm
    let sum = 0
    for (let i = 0; i < 9; i++) {
      let digit = parseInt(id[i])

      // Multiply every second digit by 2
      if (i % 2 === 1) {
        digit *= 2
        // If result is two digits, add them together
        if (digit > 9) {
          digit = Math.floor(digit / 10) + (digit % 10)
        }
      }

      sum += digit
    }

    // Valid Israeli ID if sum is divisible by 10
    if (sum % 10 !== 0) {
      return {
        israeliId: {
          message: 'Invalid Israeli ID number',
        },
      }
    }

    return null
  }
}

export function EventLocationRequiredFields(form: FormGroup, destroyer: DestroyRef) {
  const _fields = ['lat', 'lon', 'location_address', 'location_display_name', 'location_name', 'entrances']
  const swtichRequire = (status: boolean, fields = _fields) => {
    for (const field of fields) {
      if (field in form.controls) {
        const control = form.controls[field] as AbstractControl
        if (status && !control.hasValidator(Validators.required)) {
          control.setValidators([Validators.required])
          control.updateValueAndValidity({
            emitEvent: false,
          })
        } else if (!status && control.hasValidator(Validators.required)) {
          control.removeValidators([Validators.required])
          control.updateValueAndValidity({
            emitEvent: false,
          })
        }
      }
    }
  }
  const setRequired = (fields: string[]) => {
    for (const field of fields) {
      if (field in form.controls) {
        const control = form.controls[field] as AbstractControl
        if (!control.hasValidator(Validators.required)) {
          control.setValidators([Validators.required])
          control.updateValueAndValidity({
            emitEvent: false,
          })
        }
      }
    }
  }
  const checker = () => {
    swtichRequire(false)
    if (form.get('entrances')?.value) {
      setRequired(['entrances', 'location_display_name', 'lat', 'lon', 'location_address', 'location_name'])
    }
    if (form.get('set_predefined_location')?.value) {
      setRequired(['entrances', 'location_display_name'])
    }
    if (form.get('location_display_name')?.value || form.get('location_address')?.value || form.get('location_name')?.value) {
      setRequired(['location_display_name', 'lat', 'lon', 'location_address', 'location_name'])
    }
  }
  if (form.touched) {
    checker()
  }
  form.valueChanges.pipe(takeUntilDestroyed(destroyer)).subscribe(() => {
    checker()
  })
}

export function EventLocationRequiredFields2(form: FormGroup, destroyer: DestroyRef) {
  const _fields = ['lat', 'lon', 'address', 'display_name', 'name']
  const swtichRequire = (status: boolean, fields = _fields) => {
    for (const field of fields) {
      if (field in form.controls) {
        const control = form.controls[field] as AbstractControl
        if (status && !control.hasValidator(Validators.required)) {
          control.setValidators([Validators.required])
          control.updateValueAndValidity({
            emitEvent: false,
          })
        } else if (!status && control.hasValidator(Validators.required)) {
          control.removeValidators([Validators.required])
          control.updateValueAndValidity({
            emitEvent: false,
          })
        }
      }
    }
  }
  const setRequired = (fields: string[]) => {
    for (const field of fields) {
      if (field in form.controls) {
        const control = form.controls[field] as AbstractControl
        if (!control.hasValidator(Validators.required)) {
          control.setValidators([Validators.required])
          control.updateValueAndValidity({
            emitEvent: false,
          })
        }
      }
    }
  }
  const checker = () => {
    swtichRequire(false)
    if (form.get('display_name')?.value || form.get('address')?.value || form.get('name')?.value) {
      setRequired(['display_name', 'lat', 'lon', 'address', 'name'])
    }
  }
  if (form.touched) {
    checker()
  }
  form.valueChanges.pipe(takeUntilDestroyed(destroyer)).subscribe(() => {
    checker()
  })
}
